

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "ordersn",
        label: "工单号",
        width: 75,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 75,
    },
    {
        prop: "meet_vehicle_name",
        label: "接车人",
        width: 75,
    },
    {
        prop: "order_offer_price",
        label: "报价金额",
        width: 75,
    },
    {
        prop: "payment",
        label: "结算金额",
        width: 75,
    },
    {
        prop: "advance_price",
        label: "预收退款金额",
        width: 75,
    },
    {
        prop: "advance_price",
        label: "待付款",
        width: 75,
    },
    {
        prop: "order_crd_code_text",
        label: "车牌号码",
        width: 75,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 75,
    },
    {
        prop: "send_for_repair",
        label: "送修人",
        width: 75,
    }
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, permissionList,
} from "@/api/http";


import {Request} from '@/api/request';
import {validateInput, validateClass} from "@/assets/js/formRules";
import {partsFormType} from "@/assets/types/common";
import {useRoute, useRouter} from 'vue-router'

export default defineComponent({
    name: "otherList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['其他应付']);
        
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            type = ref(''),
            roleList = ref({} as any),
            route: any = useRoute(),
            Router: any = useRouter(),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search: ''
            }),
            selectList = ref({
                type: [],
                zf: [],
                staff: [],
                branch: []
            }),
            form_rules: any = {
                //fixed_name fixed_price time branch_id fixed_type
                pay_type: {required: true, message: '必填', trigger: 'blur'},
                admin_id: {required: true, message: '必填', trigger: 'blur'},
            },
            remote_loading = ref(false),
            screenParameter = ref({
                type: null,
                search: '',
                start_time: null,
                end_time: null,
                page: currentPage.value,
                pagesize: pageSize.value,
                status: 0,
            } as any),
            dialog_model = ref(false),
            dialogTitle = ref("新增配件"),
            dialog_index = 0,
            dialog_load = ref(false),
            formRef = ref(null),
            form = ref({} as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                cost_price: [{required: true, message: '必填', trigger: "change"}],
                mountings_type_pid: [{required: true, message: '必填', trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'otherList',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                Request.axiosInstance({
                    url: 'adminapi/order/collectinadvance',
                    data: {
                        ...screenParameter.value,
                        page: currentPage.value,
                        pagesize: pageSize.value
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    
                })
                
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                // screenParameter[key] = e;
                // if(key == 'mountings_type_pid')
                // {
                //     screenParameter.value.mountings_type_id = null
                //     Request.axiosInstance({
                //         url: 'adminapi/MountingsType/list',
                //         data: {pid: screenParameter.value.mountings_type_pid}
                //     }).then((res: any) => {
                //          selectList.value.classificationb = res?.content?.list
                //     })
                //     return 
                // }
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({search: e});
            },
            formSelectChange = (e: number) => {
                getSelectData({type_pid: e});
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            screenChange = (e: any, key: string): void => {
                
                if (key == "time") {
                    screenParameter.value["start_time"] = e ? (e[0] as Date).getTime() / 1000 : null
                    screenParameter.value["end_time"] = e ? (e[1] as Date).getTime() / 1000 : null
                }
                
                getTableData();
            },
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    let data: any = {...form.value, id: 0};
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({type_pid: form.value.mountings_type_pid});
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            _form_submit = () => {
                let date = Math.floor(form.value.pay_time.getTime()/1000);
                let data = {...form.value,pay_time:date};
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid) return
                    
                    dialog_load.value = true
                    Request.axiosInstance({
                        url: 'adminapi/Order/prepareRefund',
                        data: data
                    }).then((res) => {
                        dialog_load.value = false
                        if (res.status != 202) return
                        dialog_model.value = false;
                        getTableData();
                    })
                });
            },
            
            _option = (url: string, data: any) => {
                Router.push({
                    path: url,
                    query: data
                })
            },
            _purchaseMarkin = (id: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/purchaseMarkin',
                    data: {purchase_id: id}
                }).then((res: any) => {
                    getTableData()
                })
            },
            _upstatus = (id: number) => {
                
                Request.axiosInstance({
                    url: 'adminapi/Order/updateStatus',
                    data: {order_id: id}
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                })
                
                
            },
            _implementPurchaseCope = (id: number, i: number) => {
                form.value = {
                    ordersn: tableData.value[i].ordersn,
                    advance_price: tableData.value[i].advance_price,
                    order_crd_code_text: tableData.value[i].order_crd_code_text,
                    order_id:id,
                    pay_time: new Date(),
                }
                dialog_model.value = true;
                
                
            },
            _incomeUpstar = (id: Number, type: Number) => {
                
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/incomeUpstar',
                    data: {income_id: id, type}
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                })
                
            }
        
        
        onMounted(() => {
            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/expenditureType',
                    data: {status: 1}
                }),
                Request.axiosInstance({
                    url: 'adminapi/Basicset/totalList',
                    data: {basicset_type: 3}
                }),
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/constructors',
                    data: {}
                }),
            
            ]).then((res: any) => {
                console.log(res)
                selectList.value.type = res[0]?.content?.list
                selectList.value.zf = res[1]?.content?.list
                selectList.value.staff = res[2]?.content?.staff
                selectList.value.branch = res[2]?.content?.branch
            })
            
            getTableData();
            
            
        });
        
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            selectList,
            remote_loading,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            type,
            _option,
            _purchaseMarkin,
            screenParameter,
            dialog_model,
            screenChange,
            _incomeUpstar,
            dialog_index,
            _form_submit,
            form_rules,
            dialog_load,
            _upstatus,
            _implementPurchaseCope,
            roleList
        };
    },
});
